<template>
    <section
        id="dashboard"
        v-loading="loading"
    >
        <el-container>
            <el-input
                v-model="search"
                placeholder="Search text"
                style="width: 400px"
            />
            <el-select
                v-model="formType"
                placeholder="Form Type"
                style="width: 200px"
            >
                <el-option
                    label="All Forms"
                    :value="null"
                />
                <el-option
                    label="GOOD DESIGN"
                    value="gooddesign"
                />
                <el-option
                    label="GREEN GOOD DESIGN"
                    value="greengooddesign"
                />
                <el-option
                    label="Europe 40 under 40"
                    value="europe40under40"
                />
                <el-option
                    label="International Architecture"
                    value="internationalarchitecture"
                />
                <el-option
                    label="American Architecture"
                    value="americanarchitecture"
                />
                <el-option
                    label="Lighting"
                    value="lighting"
                />
                <el-option
                    label="Future House"
                    value="house"
                />
            </el-select>
            <el-select
                v-model="formDate"
                placeholder="Form Date"
                style="width: 200px"
            >
                <el-option
                    label="All Dates"
                    :value="null"
                />
                <el-option
                    label="2026"
                    value="2026"
                />
                <el-option
                    label="2025"
                    value="2025"
                />
                <el-option
                    label="2024"
                    value="2024"
                />
                <el-option
                    label="2023"
                    value="2023"
                />
                <el-option
                    label="2022"
                    value="2022"
                />
                <el-option
                    label="2021"
                    value="2021"
                />
            </el-select>
            <el-button
                type="primary"
                @click="loadData"
            >
                Search
            </el-button>
            <el-button
                v-if="formType"
                type="primary"
                @click="downloadCSV"
            >
                Download CSV
            </el-button>
        </el-container>
        <el-table
            :default-sort="{ prop: 'id', order: 'descending' }"
            :data="tableData"
            stripe
            style="width: 100%"
            @sort-change="handleSortChange"
        >
            <el-table-column
                prop="id"
                label="ID"
                width="70"
                sortable
            />
            <el-table-column
                prop="form_type"
                label="Type"
                width="80"
                align="center"
                sortable
            />
            <el-table-column
                prop="created_at"
                label="Created At"
                sortable
            />
            <el-table-column
                prop="paid_at"
                label="Paid At"
                sortable
            />
            <el-table-column
                prop="pay_method"
                label="Payment Method"
                sortable
            />
            <el-table-column
                prop="payment_reference"
                label="Auth Approval Code"
                sortable
            />
            <el-table-column
                fixed="right"
                label=""
                width="120"
            >
                <template slot-scope="{ row }">
                    <el-button
                        icon="el-icon-edit"
                        size="small"
                        @click="handleShowDetails(row)"
                    >
                        View
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :page-sizes="[10, 20, 30, 40]"
            layout="sizes, prev, pager, next, total"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        />
        <el-dialog
            id="printable"
            :title="modalTitle"
            :visible.sync="dialogVisible"
            width="1000px"
        >
            <template v-if="rowToShow">
                <template
                    v-for="(section, idx) in rowToShow.content"
                    style="margin-bottom: 20px"
                >
                    <el-row
                        :key="'title' + idx"
                        class="detailrow"
                        :gutter="10"
                    >
                        <el-col
                            v-if="idx == 0"
                            style="padding-bottom: 5px"
                            span="24"
                            align="right"
                        >
                            <el-button
                                v-if="disabled"
                                size="medium"
                                icon="el-icon-edit"
                                @click="toggleEdit()"
                            >
                                Edit Form
                            </el-button>
                            <el-button
                                v-if="!disabled"
                                size="medium"
                                icon="el-icon-document-delete"
                                @click="saveFormData()"
                            >
                                Save Data
                            </el-button>
                            <el-button
                                v-if="!disabled"
                                size="medium"
                                icon="el-icon-document-delete"
                                @click="toggleEdit()"
                            >
                                Cancel
                            </el-button>
                            <el-button
                                size="medium"
                                @click="downloadForm()"
                            >
                                Download Form
                            </el-button>
                        </el-col>
                        <el-col :span="idx == 0 ? 8 : 24">
                            {{ section.title }}
                        </el-col>
                        <el-col
                            v-if="idx == 0"
                            span="16"
                            align="right"
                        >
                            <el-popconfirm
                                v-loading.fullscreen.lock="fullScreenLoading"
                                title="Are you sure?"
                                @confirm="sendInvoice(true)"
                            >
                                <el-button
                                    slot="reference"
                                    size="medium"
                                >
                                    Send Pre-Invoice
                                </el-button>
                            </el-popconfirm>
                            <el-popconfirm
                                title="Are you sure?"
                                @confirm="sendInvoice()"
                            >
                                <el-button
                                    slot="reference"
                                    size="medium"
                                >
                                    Send Invoice
                                </el-button>
                            </el-popconfirm>
                            <el-button
                                v-if="rowToShow.proforma"
                                size="medium"
                                @click="getInvoice(rowToShow.id, 'proforma')"
                            >
                                Download Pre-Invoice
                            </el-button>
                            <span>
                                <el-button
                                    v-if="rowToShow.invoice"
                                    size="medium"
                                    @click="getInvoice(rowToShow.id, 'invoice')"
                                >Download Invoice</el-button>
                            </span>
                        </el-col>
                    </el-row>
                    <el-row
                        v-if="section.type == 'cols'"
                        :key="'detailrow' + idx"
                        class="detailformfield"
                        :gutter="10"
                    >
                        <template v-for="(field, fieldId) in section.fields">
                            <el-col
                                :key="'fieldname' + idx + fieldId"
                                class="labelfield"
                                :title="field.fieldname"
                                span="6"
                            >
                                {{ field.fieldname }}
                            </el-col>
                            <el-col
                                :key="'fieldvalue' + idx + fieldId"
                                class="valuefield"
                                span="6"
                            >
                                <el-input
                                    v-if="!disabled"
                                    v-model="field.value"
                                />
                                <span v-if="disabled">{{
                                    field.value ? field.value : "-"
                                }}</span>
                            </el-col>
                        </template>
                    </el-row>
                    <div
                        v-else
                        :key="'detailtext' + idx"
                    >
                        <el-input
                            v-if="!disabled"
                            v-model="section.value"
                            type="textarea"
                            :rows="6"
                        />
                        <span v-if="disabled">{{ section.value }}</span>
                    </div>
                </template>
            </template>
            <el-row
                class="detailrow"
                :gutter="10"
            >
                <el-col span="24">
                    Files
                </el-col>
            </el-row>
            <el-row
                v-if="
                    rowToShow && rowToShow.files && rowToShow.files.length > 0
                "
                :gutter="10"
            >
                <S3Browser
                    :application-id="rowToShow.id"
                    :files="rowToShow.files"
                />
            </el-row>
            <!--<el-row
                :gutter="10"
                v-if="
                    rowToShow && rowToShow.files && rowToShow.files.length > 0
                "
            >
                <el-col
                    span="6"
                    v-for="(file, fileIdx) in rowToShow.files"
                    :key="'file' + fileIdx"
                >
                    <el-button @click="getFile(file)" icon="el-icon-download"
                        >Download File {{ fileIdx + 1 }}
                    </el-button>
                </el-col>
            </el-row>
            <el-row :gutter="10" v-else>
                <el-col span="24"> No files uploaded </el-col>
            </el-row>-->
        </el-dialog>
    </section>
</template>

<script>
import adminApi from '../api'
import S3Browser from '@/core/components/S3Browser'
export default {
    name: 'Dashboard',
    components: { S3Browser },
    data() {
        if (!this.loading) {
            return {
                loading: false,
                search: null,
                formType: null,
                formDate: null,
                currentPage: 1,
                pageSize: 10,
                descriptionColumns: 2,
                sort: { prop: 'id', order: 'descending' },
                total: 0,
                tableData: [],
                dialogVisible: false,
                rowToShow: null,
                fullScreenLoading: false,
                disabled: true,
                contentBackup: null,
            }
        }
    },
    created() {
        this.loadData()
    },
    computed: {
        modalTitle() {
            if (this.rowToShow) {
                if (this.rowToShow.form_type == 'GD')
                    return (
                        '#TCA-' +
                        this.rowToShow.form_type +
                        '-' +
                        this.rowToShow.id
                    )
                if (this.rowToShow.form_type == 'GGD')
                    return (
                        '#ECADUS-' +
                        this.rowToShow.form_type +
                        '-' +
                        this.rowToShow.id
                    )
                if (this.rowToShow.form_type == 'E40U40')
                    return (
                        '#ECADUS-' +
                        this.rowToShow.form_type +
                        '-' +
                        this.rowToShow.id
                    )
                if (this.rowToShow.form_type == 'IAA')
                    return (
                        '#TCA-' +
                        this.rowToShow.form_type +
                        '-' +
                        this.rowToShow.id
                    )
                if (this.rowToShow.form_type == 'AAA')
                    return (
                        '#TCA-' +
                        this.rowToShow.form_type +
                        '-' +
                        this.rowToShow.id
                    )
            }
            return ''
        },
    },
    methods: {
        toggleEdit() {
            if (this.disabled) {
                this.contentBackup = JSON.parse(JSON.stringify(this.rowToShow.content))
            } else {
                this.rowToShow.content = JSON.parse(JSON.stringify(this.contentBackup))
                this.contentBackup = null
            }
            this.disabled = !this.disabled
        },
        saveFormData() {
            this.loading = true
            adminApi
                .updateForm(this.rowToShow.id, this.rowToShow.content)
                .then(() => {
                    this.$notify({
                        title: 'Success',
                        message: 'Form updated successfully!',
                        type: 'success',
                        duration: 6000,
                    })
                    this.disabled = true
                    this.contentBackup = null
                })
                .catch(() => {
                    this.$notify({
                        title: 'Error',
                        message: 'Could not save changes. Please try again.',
                        type: 'error',
                        duration: 6000,
                    })
                })
                .finally(() => {
                    this.loading = false
                })
        },
        getInvoice(form_id, type) {
            window.location.href =
                '/api/v1/form-submissions/getInvoice/' +
                form_id +
                '?type=' +
                type +
                '&token=' +
                this.$auth.token()
        },
        downloadCSV() {
            let url = '/api/v1/admin/csv?token=' + this.$auth.token()
            if (this.formType) {
                url = url + '&formType=' + this.formType
            }
            window.open(url, '_blank').focus()
        },
        downloadForm() {
            var html =
                '<html><head><link href=\'https://awardapplication.com/css/app.css\' rel=\'stylesheet\'></head>'
            html += document.getElementById('printable').innerHTML

            html += '</html>'

            var printWin = window.open(
                '',
                '',
                'left=0,top=0,width=1024,height=768,toolbar=0,scrollbars=0,status  =0'
            )
            printWin.document.write(html)
            printWin.document.close()
            printWin.focus()
            printWin.print()
            //printWin.close();
        },
        sendInvoice(proforma) {
            this.fullScreenLoading = true
            adminApi
                .issueInvoice(this.rowToShow.id, proforma)
                .then((r) => {
                    if (r && r.data && r.data.success) {
                        this.$notify({
                            title: 'Success',
                            message: 'The invoice was sent successfully!',
                            type: 'success',
                            duration: 10000,
                        })
                        this.loadData()
                        if (proforma) {
                            this.rowToShow.proforma = true
                        } else {
                            this.rowToShow.invoice = true
                        }
                    } else {
                        this.$notify({
                            title: 'Error',
                            message:
                                'Something went wrong while issuing/sending the invoice. Please try again.',
                            type: 'error',
                            duration: 10000,
                        })
                    }
                })
                .catch((err) => {
                    this.$notify({
                        title: 'Error',
                        message:
                            'Something went wrong! Please contact the webmaster mentioning the form id.',
                        type: 'error',
                        duration: 10000,
                    })
                })
                .finally(() => {
                    this.fullScreenLoading = false
                })
        },
        getFile(fileName, type) {
            window
                .open(
                    '/api/v1/admin/file?filename=' +
                        fileName +
                        '&token=' +
                        this.$auth.token(),
                    '_blank'
                )
                .focus()
        },
        handleShowDetails(row) {
            this.rowToShow = row
            this.dialogVisible = true
        },
        handleSortChange({ column, prop, order }) {
            if (!order) {
                this.sort = { prop: 'id', order: 'desc' }
            } else {
                this.sort = { prop: prop, order: order }
            }
            this.loadData()
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.loadData()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.loadData()
        },
        loadData() {
            this.loading = true
            adminApi
                .getList({
                    search: this.search,
                    formType: this.formType,
                    formDate: this.formDate,
                    page: this.currentPage,
                    perPage: this.pageSize,
                    orderBy: this.sort.prop,
                    orderWay: this.sort.order == 'ascending' ? 'asc' : 'desc',
                })
                .then((r) => {
                    this.tableData = r.data.data
                    this.total = r.data.total
                })
                .catch((err) => {})
                .finally(() => {
                    this.loading = false
                })
        },
    },
}
</script>

<style lang="scss" scoped>
.el-select--mini .el-input__inner {
    padding-right: 0 !important;
}
</style>
